export const GET_ALL_JOIN_REQUESTS = "GET_ALL_JOIN_REQUESTS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_JOIN_REQUESTS = "START_LOADING_JOIN_REQUESTS";
export const STOP_LOADING_JOIN_REQUESTS = "STOP_LOADING_JOIN_REQUESTS";
export const ERROR_LOADING_JOIN_REQUESTS = "ERROR_LOADING_JOIN_REQUESTS";